import { BonusButton } from "@shared/components";
import { useLobbyParams } from "@shared/hooks/lobby/lobby";
import { useUserState } from "@shared/hooks/user";
import { hasUser } from "@shared/utils/users";
import React from "react";
import { useHistory } from "react-router-dom";

import Auth from "./AuthPopup";
import { UserPopup } from "./UserPopup";

const Popup = ({
  updateBalance,
  authData,
  onAuthExit,
  onAuthEnter,
  bonus,
  showBonusModal,
}) => {
  const { loading } = authData;
  const lobbyParams = useLobbyParams();
  const history = useHistory();
  const url = history.location.pathname;
  const isGamesVisible = url.includes("/games");
  const userState = useUserState();
  const isAuth = hasUser(userState);

  return (
    <div id="loginForm" className="account">
      {!lobbyParams?.sweepstakes && isAuth && bonus && bonus.available && (
        <div style={{ display: "inline-block", marginRight: 16 }}>
          <BonusButton bonus={bonus} onClick={showBonusModal} />
        </div>
      )}
      {isAuth || isGamesVisible ? (
        <UserPopup
          updateBalance={updateBalance}
          onAuthExit={onAuthExit}
          bonus={bonus}
          showBonusModal={showBonusModal}
        />
      ) : (
        <Auth loading={loading} onAuthEnter={onAuthEnter} />
      )}
    </div>
  );
};

export default Popup;
